module.exports = __webpack_public_path__ + "static/media/pkm-klp1.269c0c8a.JPG";